// extracted by mini-css-extract-plugin
module.exports = {"tab":"QOQBy7C8","info":"NMD_tjDm"};